import React from 'react';
import { OfferBanner } from '../components/OfferBanner';
import { HeroSection } from '../components/HeroSection';
import { EmotionalConnection } from '../components/EmotionalConnection';
import { AvatarPains } from '../components/AvatarPains';
import { SolutionBenefits } from '../components/SolutionBenefits';
import { ProductOffer } from '../components/ProductOffer';
import { Bonuses } from '../components/Bonuses';
import { BreedGallery } from '../components/BreedGallery';
import { EbookPreview } from '../components/EbookPreview';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
export function LandingPage() {
  return <div className="min-h-screen font-body text-deep-brown selection:bg-soft-rose selection:text-white" data-id="element-410">
      <OfferBanner data-id="element-411" />
      <main data-id="element-412">
        <HeroSection data-id="element-413" />
        <EmotionalConnection data-id="element-414" />
        <AvatarPains data-id="element-415" />
        <SolutionBenefits data-id="element-416" />
        <BreedGallery data-id="element-417" />
        <EbookPreview data-id="element-418" />
        <ProductOffer data-id="element-419" />
        <Bonuses data-id="element-420" />
        <Testimonials data-id="element-421" />
        <FAQ data-id="element-422" />
      </main>
      <Footer data-id="element-423" />
      <FloatingCTA data-id="element-424" />
    </div>;
}